export default __webpack_public_path__ + "static/media/Boots of the Exorcist.c054e120.jpg";